const BLOG_RSS_TIMING = Object.freeze({
  INSTANT: 'INSTANT',
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY'
});
export default BLOG_RSS_TIMING;